import { Collapse } from 'antd';
import { MemberTripConfig } from 'elem/compCommon/ProductConstructor/BriefGuide/Info/MemberTrip/const';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function X() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, getSystemTime } = useGlobal();
    const { locale, pathname, query } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const { timer, includePaths, includeSites } = MemberTripConfig;

    const lists: any[] =
        locale === 'mx'
            ? [
                  {
                      title: t('secX_terms_title4'),
                      desc: t('secX_terms_content4'),
                  },
                  {
                      title: t('secX_terms_title6'),
                      desc: t('secX_terms_content6'),
                  },
                  {
                      title: t('secX_terms_titleFee'),
                      desc: t('secX_terms_descFee'),
                  },
              ]
            : locale === 'jp'
            ? [
                  {
                      title: t('secX_terms_title1'),
                      desc: t('secX_terms_content1'),
                  },
              ]
            : locale === 'ca'
            ? [
                  //   {
                  //       title: t('secX_terms_title1'),
                  //       desc: t('secX_terms_content1'),
                  //   },
                  {
                      title: t('secX_terms_title2'),
                      desc: t('secX_terms_content2'),
                  },
                  {
                      title: t('secX_terms_title3'),
                      desc: t('secX_terms_content3'),
                  },
              ]
            : [
                  //   {
                  //       title: t('secX_terms_title1'),
                  //       desc: t('secX_terms_content1'),
                  //   },
                  //   {
                  //       title: t('secX_terms_title2'),
                  //       desc: t('secX_terms_content2'),
                  //   },
                  {
                      title: t('secX_terms_title3'),
                      desc: t('secX_terms_content3'),
                  },
                  {
                      title: t('secX_terms_title4'),
                      desc: t('secX_terms_content4'),
                  },
                  {
                      title: t('secX_terms_title6'),
                      desc: t('secX_terms_content6'),
                  },
                  //   {
                  //       title: t('secX_terms_title5'),
                  //       desc: t('secX_terms_content5'),
                  //   },
                  locale !== 'us' && {
                      title: t('secX_terms_titleFee'),
                      desc: t('secX_terms_descFee'),
                  },
              ].filter(Boolean);

    const [listsAll, setListsAll] = useState(lists);

    useEffect(() => {
        let serverTime = getSystemTime();
        if (!serverTime || serverTime < 1000000) {
            serverTime = new Date().getTime();
        }
        // 测试用
        if (query?.timerStart && query?.timerEnd) {
            timer.start = `${query?.timerStart}`;
            timer.end = `${query?.timerEnd}`;
        }
        const flag =
            includePaths?.includes(pathname) &&
            includeSites?.includes(locale) &&
            serverTime >= new Date(timer?.start)?.getTime() &&
            serverTime < new Date(timer?.end)?.getTime();
        if (flag) {
            setListsAll([
                ...lists,
                {
                    title: t('secX_terms_titleMember'),
                    desc: t.rich('secX_terms_contentMember', {
                        a: (text: string) => (
                            <a className="desc-link" href={`https://www.ecoflow.com/${locale}`} target="_self" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    }),
                },
            ]);
        }
    }, [query]);

    return (
        <section className={`dpu-detail-X dpu-detail-section ${css['dpu-detail-X']}`}>
            <p className="text">
                {t.rich('secX_text', {
                    w: (text: any) => <span className="white-text">{text}</span>,
                })}
            </p>

            {locale !== 'jp' && (
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    // defaultActiveKey={0}
                    // onChange={setActive}
                    // accordion={true}
                    expandIcon={({ isActive }: any) => {
                        return (
                            <svg
                                className={`collapse-icon ${isActive ? 'active' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                            >
                                <path d="M17.5 15L12.5 10L7.5 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        );
                    }}
                    expandIconPosition="right"
                >
                    {listsAll?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            )}
        </section>
    );
}
